import { render, staticRenderFns } from "./ResourceBasicInfo.vue?vue&type=template&id=450a825c"
import script from "./ResourceBasicInfo.vue?vue&type=script&lang=js"
export * from "./ResourceBasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports